import apiClient from "../axiosClient";
import { apiCallWrapper } from "../utils/commonUtils";

class DialerService {
	static async scheduleCallBack(caseId: string, phoneNumber: string): Promise<boolean> {
		const response = await apiCallWrapper(() => apiClient.post(`/api/v1/initiate_call/case/${caseId}/${phoneNumber}`));
		
		if (response && response.status === 200) {
			alert("Call Scheduled Successfully");
			return true;
		} else {
			alert("Error while loading field list. Error: " + response.data.message);
			return false;
		}
	}
}

export default DialerService;